import React, { FC, memo, useMemo } from 'react';
import { useRequest } from 'ahooks';
import { Col, Empty, Row, Spin } from 'udesk-ui';
import { Content, Wrapper } from './components';
import Ellipsis from 'src/components/common/Ellipsis';
import { getCallUdeskCustomer } from 'src/api/call/udesk/customer';
import { transformToCustomerInfo } from './utils';

interface TemplateProps {
    style?: React.CSSProperties;
    height?: number;
    callId?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { style, height, callId } = props;

    const contentHeight = useMemo(() => {
        return height && height >= 38 ? height - 38 : undefined;
    }, [height]);

    const { data, loading } = useRequest(
        () =>
            getCallUdeskCustomer({
                params: {
                    callId: callId!,
                },
            }),
        {
            ready: !!callId,
            refreshDeps: [callId],
        }
    );

    const customerInfo = transformToCustomerInfo(data?.data);

    return (
        <Wrapper style={{ height, ...style }}>
            <Spin spinning={loading}>
                {customerInfo.length ? (
                    <Content height={contentHeight}>
                        {customerInfo?.map((content, idx) => (
                            <Row key={idx} style={{ marginBottom: 6 }} gutter={4} wrap={false}>
                                <Col flex="120px">
                                    <Ellipsis
                                        style={{ width: '100%', textAlign: 'right' }}
                                        text={content.key}
                                        suffix="："
                                    />
                                </Col>

                                <Col flex="auto">
                                    <Ellipsis text={content.value as string} />
                                </Col>
                            </Row>
                        ))}
                    </Content>
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
            </Spin>
        </Wrapper>
    );
});

export default Template;
